import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { quantityInputStyles } from "@store/theme/common/mixins";
import { typography } from "@store/theme/common/styleguide";
import { css } from "styled-components";

Object.assign(cartLineQuantityStyles, {
    editableQuantityTextField: {
        sizeVariant: "small",
        labelProps: {
            variant: "legend",
            ...typography.legend, // We need to do this since the variant is not applied correctly
            css: css`
                min-height: 0;
            `,
        },
        cssOverrides: {
            inputSelect: css`
                ${quantityInputStyles()}
            `,
        },
    },
});
